/**
 * Audit Log control for Cost Breakdown sheets.
 * Every estimation table write lands in estimation_audit_log — this opens that trail.
 */

import React, { useMemo, useState } from 'react';
import AuditLogModal from '../../common/AuditLogModal';
import { HeaderButton } from './CbUi';

/**
 * @param {string|string[]} tableName - estimation_audit_log.table_name (or list)
 * @param {number|string} [estimateId] - scopes to details.estimate_id when present
 * @param {string} [title]
 * @param {string} [accentColor]
 */
const CbAuditLogButton = ({
  tableName,
  estimateId = null,
  title = 'Estimation Audit Log',
  accentColor = '#0f766e',
}) => {
  const [open, setOpen] = useState(false);

  const endpoint = useMemo(() => {
    const params = new URLSearchParams();
    if (Array.isArray(tableName)) {
      if (tableName.length) params.set('table_names', tableName.join(','));
    } else if (tableName) {
      params.set('table_name', tableName);
    }
    if (estimateId != null && estimateId !== '') {
      params.set('estimate_id', String(estimateId));
    }
    const qs = params.toString();
    return `/cost-breakdown/audit-log${qs ? `?${qs}` : ''}`;
  }, [tableName, estimateId]);

  return (
    <>
      <HeaderButton onClick={() => setOpen(true)} title="Trace every create / update / delete / import on this sheet">
        📜 Audit Log
      </HeaderButton>
      <AuditLogModal
        isOpen={open}
        onClose={() => setOpen(false)}
        endpoint={endpoint}
        title={title}
        accentColor={accentColor}
      />
    </>
  );
};

export default CbAuditLogButton;
